// extracted by css-extract-rspack-plugin
export default {"layout":"layout-kL6pFQ","main":"main-COuX_U"};